import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injector, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, catchError } from 'rxjs';
import { AuthHelper } from '../helpers/auth.helper';
import { ToastService } from '../services/toastr.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly toastService: ToastService,
    private readonly authHelper: AuthHelper,
    private readonly router: Router,
    private readonly injector: Injector
  ) {}

  private get translate(): TranslateService {
    return this.injector.get(TranslateService);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error) {
          const t = this.translate;
          switch (error.status) {
            case 412:
              this.toastService.showError(
                t.instant('httpErrors.reviewDataAndTryAgain'),
                error?.error?.message ?? t.instant('httpErrors.invalidUsernameOrPassword')
              );
              break;
            case 401:
              this.toastService.showError(
                t.instant('httpErrors.tryAgain'),
                t.instant('httpErrors.sessionExpired')
              );
              this.authHelper.logoutSession();
              this.router.navigate(['/auth/login']);
              break;
            case 403:
              this.toastService.showError(t.instant('httpErrors.noPermission'));
              this.router.navigate(['/control-panel']);
              break;
            case 422:
              this.toastService.showError(
                t.instant('httpErrors.reviewDataAndTryAgain'),
                error?.error?.message ?? t.instant('httpErrors.invalidData')
              );
              break;
            default:
              break;
          }
        }
        throw error;
      })
    );
  }
}
